export const mockAPIPath = {
    CATEGORY_LIST:"./data/categoryList.json",
    UPDATE_CATEGORY:"",
    FAILED_CATEGORY_REQUEST:"./data/failedTransaction.json",
    SUCCESS_TRANSACTION_LIST : "",
    FIND_TRANSACTION : "",
    CATEGORY_INTEGRATION : "",
    DEMO_CATEGORY_LIST:"",
    UPDATE_DEMO_CATEGORY:""

};

export const serverAPIPath = {
    CATEGORY_LIST:"/master/categories",
    UPDATE_CATEGORY:"/master/categories",
    CATEGORY_INTEGRATION : "/category-integration",
    FAILED_CATEGORY_REQUEST:"/category-integration/failed",
    SUCCESS_TRANSACTION_LIST : "/category-integration/success",
    FIND_TRANSACTION: "/category-integration/find",
    DEMO_CATEGORY_LIST:"/demo/categories",
    UPDATE_DEMO_CATEGORY:"/demo/categories",
};